<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(episode, idx) in placeholderEpisodes"
      :key="idx"
      gap="small"
      vertical-align="middle"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iColumn gap="extraSmall" width="fill">
        <iText font-weight="strong">
          {{ episode.title }}
        </iText>
        <iText variant="subtle" font-size="small">
          Episode {{ episode.episodeNumber }} · {{ episode.duration }} min
        </iText>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>
// Same reasoning as ShowEpisodes.vue — SmartFeedV2 + smart-feed-engine
// live outside the editor directory tree. Render a static example
// list inside the canvas preview.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "SeasonEpisodes",
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Season Episodes",
    displayIcon: "feed",
    elementGroup: "season",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({
      "default": "There are no episodes available yet.",
    }),
  ],
  computed: {
    placeholderEpisodes() {
      return [
        { title: "Episode 1: Cold Open", episodeNumber: 1, duration: 42 },
        { title: "Episode 2: Backtracks", episodeNumber: 2, duration: 38 },
        { title: "Episode 3: The Source", episodeNumber: 3, duration: 45 },
      ];
    },
  },
};
</script>
